import  { FC, useState, useRef } from "react"
// import { useEditEvent } from '@app/data/editEvent/useEditEvent.tsx'
import Button from '@mui/material/Button'
import EventNameComponent from "@pages/makeEvent/steps-components/eventName-component"
import EventTypeComponent from "@pages/makeEvent/steps-components/eventType-component"
import EventModeComponent from "@pages/makeEvent/steps-components/eventMode-component"
import { GeneralTabPanelProps } from '@/pages/eventEditing/components/types'

type FieldsNames = "event_type_id" | "event_name" | "is_private"

const GeneralTabPanel: FC<GeneralTabPanelProps> = ({ formik }) => {
	const { values } = formik
	const initialValues = {
		"event_name": values["event_name"],
		"event_type_id": values["event_type_id"],
		"is_private": values["is_private"]
	}
	const [validFieldsValues, setValidFieldsValues] = useState({initialValues})
	const preservedInitialValues = useRef(initialValues)

	// const {build, isLoading } = useEditEvent()
	// const clickHandler = () => {
	// 	build(formik.values)
	// 	console.log('i tried!')
	// }


	const setValidValue = (name: FieldsNames) => (value) => {
		setValidFieldsValues({...validFieldsValues, [name]: value})
	}

	return (
		<div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
			<EventNameComponent formik={formik} setValidValue={setValidValue("event_name")} />
			<EventTypeComponent formik={formik} setValidValue={setValidValue("event_type_id")}/>
      <EventModeComponent formik={formik} setValidValue={setValidValue("is_private")}/>
		</div>
	)
}

export default GeneralTabPanel